export default "__VITE_ASSET__EwF0CiLX__"